export default "__VITE_ASSET__B9n2w965__"